import OBase from './OBase';
import * as Geometry from '../geometry';

export default class VectorXYZ extends OBase {
  update () {
    let xVal = this.getFloatInput('X component');
    let yVal = this.getFloatInput('Y component');
    let zVal = this.getFloatInput('Z component');

    let vOutput = this.getGenericObjectOutput('Vector');
    let lOutput = this.getGenericObjectOutput('Length');

    let dataTrees = [];
    var outDataTrees = [];
    dataTrees.push(xVal);
    dataTrees.push(yVal);
    dataTrees.push(zVal);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    var outTree1 = new Geometry.DataTree();
    var outTree2 = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let val = new THREE.Vector3(
          Number(outDataTrees[0].branches[i][j]),
          Number(outDataTrees[1].branches[i][j]),
          Number(outDataTrees[2].branches[i][j])
        );

        outTree1.add(val, outDataTrees[0].paths[i]);
        outTree2.add(val.length(), outDataTrees[0].paths[i]);
      }
    }

    vOutput.value = outTree1;
    lOutput.value = outTree2;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/VectorXYZ.js